import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity, PlanOfActionEntity } from "../../../meta-data/app-meta-data.service";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";

@DwCustomContextDefinition({
    keyName: 'planofaction-outcome-context',
    display: 'Plan of Action Outcome Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.PlanOfAction,
})
@Injectable()
export class PlanOfActionOutcomeContextService extends DwCustomContextBase {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        private examinerRepositoryService: ExaminerRepositoryService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            const outcomeId =  this.getOutcomeId(resolvedContext);

            return this.examinerRepositoryService.getCheckrideOutcome(outcomeId);
        };
        
        contextDef.item = AppMetaDataItemNames.CheckRideOutcome;
        contextDef.getCustomContextKey = (resolvedContext) => {
           return this.getOutcomeId(resolvedContext);
        };

        contextDef.useItemMetaData = true;
    }

    getOutcomeId(resolvedContext:any) {
        const planOfAction: PlanOfActionEntity = resolvedContext.data;
        
        return planOfAction?.PlanOfActionResult?.CheckRideOutcomeId;
    }
} 